import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import NearbyStationItem from './NearbyTrainPositionStationItem'
import NearbyTwinStationItem from './NearbyTrainPositionTwinStationItem'
import TokyuParallelStationItem from './TrainPositionTokyuParallelStationItem'
import BlankRow from './TrainPositionBlankRow'
import { showAlert } from '../../utils/Alert'

const NearbyTrainPositionList = (props) => {
  const { trains, themeName, stationId } = props
  const intl = useIntl()

  const stations = () => {
    return MasterData.allStationsOnNearStation(stationId)
  }

  return (
    <ul className="d-TrainPosition-station d-Train-mystation">
      {stations().map((station, i) => {
        if (Array.isArray(station)) {
          return (
            <div key={`stationGroup${i}`} className={`d-TrainPosition-stationItemContainer`}>
              <NearbyTwinStationItem
                key={`station${i}-0-${station[0].id ?? 'null'}`}
                trains={trains}
                station={station[0]}
                themeName={themeName}
              />
              <NearbyTwinStationItem
                key={`station${i}-1-${station[1].id ?? 'null'}`}
                trains={trains}
                station={station[1]}
                themeName={themeName}
              />
            </div>
          )
        } else {
          return (
            <NearbyStationItem
              key={`station${i}-${station.id ?? 'null'}`}
              trains={trains}
              station={station}
              themeName={themeName}
            />
          )
        }
      })}
    </ul>
  )
}

NearbyTrainPositionList.propTypes = {
  trains: PropTypes.array.isRequired,
  themeName: PropTypes.string.isRequired,
  stationId: PropTypes.string.isRequired,
}

export default NearbyTrainPositionList
